import { render, staticRenderFns } from "./ListingLavorazioniGallery.vue?vue&type=template&id=6f980636"
import script from "./ListingLavorazioniGallery.vue?vue&type=script&lang=js"
export * from "./ListingLavorazioniGallery.vue?vue&type=script&lang=js"
import style0 from "./ListingLavorazioniGallery.vue?vue&type=style&index=0&id=6f980636&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports